<template>
  <mds-layout-grid>
    <mds-row v-if="isProgramBasedMode">
      <mds-col>
        <mds-fieldset :class="$style['field-item']" :legend="translate('program')" size="small">
          <span>{{ validSelectedProgramsString }}</span>
        </mds-fieldset>
      </mds-col>
    </mds-row>
    <mds-row>
      <mds-col :cols="4">
        <mds-fieldset
          :class="$style['field-item']"
          :legend="translate('maxFeePercentage')"
          size="small"
        >
          <span>{{ formatter.number(schedule.maxFee, 'shortDecimal') }}</span>
        </mds-fieldset>
      </mds-col>
      <mds-col :cols="5">
        <mds-fieldset :class="$style['field-item']" :legend="translate('maxDiscount')" size="small">
          <span>{{ maxDiscountDescription }}</span>
        </mds-fieldset>
      </mds-col>
    </mds-row>
  </mds-layout-grid>
</template>

<script>
import MwcVueHelperMixin, { MwcConfigMixin } from 'mwc-vue-component-helper';
import { MdsLayoutGrid, MdsRow, MdsCol } from '@mds/layout-grid';
import MdsFieldset from '@mds/fieldset';
import MaxFeeMetadataMixin from '../../mixins/metadata/max-fee-mixin';

export default {
  name: 'max-fee-details-view',
  components: {
    MdsLayoutGrid,
    MdsRow,
    MdsCol,
    MdsFieldset,
  },
  mixins: [MwcVueHelperMixin, MwcConfigMixin, MaxFeeMetadataMixin],
  props: {
    schedule: Object,
  },
};
</script>

<style lang="scss" module>
@import '@mds/typography';
@import '@mds/link';
.field-item {
  margin-bottom: $mds-space-2-x;
  span {
    @include mds-body-text-s();
    display: inline-block;
    max-width: 400px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .mds-fieldset__legend {
    margin-bottom: $mds-space-1-x;
  }
}

.max-discount-description::before {
  color: #ccc;
  content: '\2022';
  margin-left: $mds-space-quarter-x;
  padding-right: $mds-space-three-quarter-x;
}
</style>
